var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"fillRule":"nonzero"},React.createElement("path",{"fill":"currentColor","d":"M14.4216069,1 L23.2385083,9.50290729 L14.4216069,18.0059181 L13.7843537,17.3915662 L21.427,10.02 L1,10.0205341 L1,8.98548753 L21.428,8.985 L13.7843537,1.61435187 L14.4216069,1 Z","id":"arrow"}))));
}

Arrow.defaultProps = {"viewBox":"0 0 24 19","version":"1.1"};

module.exports = Arrow;

Arrow.default = Arrow;
